
import { defineComponent, PropType } from "@nuxtjs/composition-api";
import type { Location } from "vue-router";
export default defineComponent({
  name: "VBreadcrumb",
  props: {
    options: {
      type: Array as PropType<
        Array<{
          to?: string | Location;
          label: string;
        }>
      >,
      default: () => [],
    },
    theme: {
      type: String as PropType<"dark" | "white">,
      default: "dark",
    },
  },
});
